<template>
  <div>
    <div class="mb-1">
      <h4 class="mb-0">
        Настройки
      </h4>
      <div class="text-muted small">
        Параметры, которые меняются без деплоя. Значения применяются сразу; «по умолчанию» задаётся в коде бэкенда.
      </div>
    </div>

    <b-alert
      v-if="errorText"
      show
      variant="danger"
    >
      {{ errorText }}
    </b-alert>

    <b-card no-body>
      <b-tabs
        v-if="categories.length"
        :value="activeIndex"
        card
        lazy
        @input="selectTab"
      >
        <b-tab
          v-for="category in categories"
          :key="category.id"
          :title="category.label"
        >
          <div
            v-if="category.description"
            class="text-muted mb-1"
          >
            {{ category.description }}
          </div>
          <settings-category-form :category="category.id" />
        </b-tab>
      </b-tabs>
      <b-card-body
        v-else-if="loading"
        class="text-center"
      >
        <b-spinner small />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BAlert, BCard, BCardBody, BSpinner, BTab, BTabs,
} from 'bootstrap-vue'
import settingsApi from '@/services/settings-api.service'
import SettingsCategoryForm from './SettingsCategoryForm.vue'

export default {
  name: 'SettingsPage',
  components: {
    BAlert, BCard, BCardBody, BSpinner, BTab, BTabs, SettingsCategoryForm,
  },
  data() {
    return {
      categories: [],
      loading: false,
      errorText: '',
    }
  },
  computed: {
    activeIndex() {
      const index = this.categories.findIndex(category => category.id === this.$route.query.category)
      return index === -1 ? 0 : index
    },
  },
  async created() {
    this.loading = true
    try {
      const res = await settingsApi.getCategories()
      this.categories = res.data
    } catch (e) {
      this.errorText = e?.response?.data?.message || 'Не удалось загрузить настройки'
    } finally {
      this.loading = false
    }
  },
  methods: {
    /** The open tab goes into ?category=, so a link can point at it */
    selectTab(index) {
      const category = this.categories[index]?.id
      if (category && category !== this.$route.query.category) {
        this.$router.replace({ query: { ...this.$route.query, category } }).catch(() => {})
      }
    },
  },
}
</script>
